var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { classNames } from '../../../utils';
import Typography from '../../typography/typography';
import * as styles from './checkbox-input.styles';
export var Checkbox = function (_a) {
    var description = _a.description, _b = _a.descriptionColor, descriptionColor = _b === void 0 ? 'textMid' : _b, testId = _a.testId, className = _a.className, onCheckboxChange = _a.onCheckboxChange, nameProp = _a.nameProp, disabled = _a.disabled, _c = _a.visible, visible = _c === void 0 ? true : _c, register = _a.register, checked = _a.checked, _d = _a.checkboxColor, checkboxColor = _d === void 0 ? 'primary' : _d, value = _a.value, id = _a.id, name = _a.name, indeterminate = _a.indeterminate;
    var checkboxChange = function (e) {
        if (onCheckboxChange) {
            onCheckboxChange({
                checked: e.target.checked,
                name: e.target.name,
                value: value,
            });
        }
    };
    return (_jsx(_Fragment, { children: visible && (_jsxs("label", __assign({ className: classNames(className, 'item-center flex gap-2') }, { children: [_jsxs("div", __assign({ className: styles.inputContainer }, { children: [nameProp && register && (_jsx("input", __assign({ id: id, disabled: disabled, "data-testid": testId, type: "checkbox", className: classNames(styles.checkboxInput, "border-".concat(checkboxColor)) }, register(nameProp)))), !nameProp && (_jsx("input", { id: id, name: name, disabled: disabled, "data-testid": testId, type: "checkbox", className: classNames(styles.checkboxInput, "border-".concat(checkboxColor)), checked: checked, ref: function (ref) {
                                if (ref)
                                    ref.indeterminate = !!indeterminate;
                            }, onChange: function (e) { return checkboxChange(e); } }))] })), typeof description === 'string' ? (_jsx(Typography, { type: "body", color: descriptionColor, text: description || '' })) : (description)] }))) }));
};
export default Checkbox;
//# sourceMappingURL=checkbox-input.js.map